import {
	forwardRef,
	ReactElement,
	Ref,
	useImperativeHandle,
	useState
} from "react";
import { IFormHandler, useFormHandler } from "client/Forms";
import { EditAppHandle } from "../EditApp";
import { useSaveApp, EditAppSavedResult } from "../useSaveApp";
import {
	EditAppBase,
	EditAppSettings,
	initialGenericState
} from "../EditAppBase";
import { createValidationConfiguration } from "client/Validation";
import { isNotEmpty, isNotNullNorUndefined } from "client/Validation/rules";
import {
	EditGenericAppViewModel,
	saveGenericApp,
	SaveGenericAppModel
} from "client/Api/Apps/EditApp/saveApp";

export type EditGenericAppProps = {
	initialSettings: EditAppSettings<EditGenericAppViewModel>;
	initiallyActivateWhoHasAccessTab: boolean;
};

export const EditGenericApp = forwardRef(
	(
		props: EditGenericAppProps,
		ref: Ref<EditAppHandle>
	): ReactElement => {
		const {
			initialSettings,
			initiallyActivateWhoHasAccessTab
		} = props;

		const [formData, setFormData] = useState<SaveGenericAppModel>(
			() => convertToSaveModel(initialSettings)
		);

		const {
			app,
			usersAndUserGroupsData
		} = initialSettings.model;

		const formHandler: IFormHandler<SaveGenericAppModel> = useFormHandler(
			formData,
			setFormData,
			validation
		);

		const save: () => Promise<EditAppSavedResult> = useSaveApp<SaveGenericAppModel>(
			formHandler,
			saveGenericApp,
			app.type
		);

		useImperativeHandle(
			ref,
			(): EditAppHandle => ({
				save
			}),
			[save]
		);

		return (
			<EditAppBase
				formHandler={formHandler}
				hasValidationErrorForSpecificSettings={false}
				initialAppSettings={app}
				usersAndUserGroupsData={usersAndUserGroupsData}
				initiallyActivateWhoHasAccessTab={initiallyActivateWhoHasAccessTab}
			/>
		);
	}
);
EditGenericApp.displayName = "EditGenericApp";

const validation = createValidationConfiguration<SaveGenericAppModel>();

validation.forScalar("name")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty()
	);

function convertToSaveModel(
	initialSettings: EditAppSettings<EditGenericAppViewModel>
): SaveGenericAppModel {
	return {
		...initialGenericState(initialSettings)
	};
}
